import React from 'react'
import ErrorModal from '../components/molecules/error-modal/error-modal'

export const wrapRootElement = ({ element }) => {
  return (
    <>
      {element}
      <ErrorModal />
    </>
  )
}